export default __webpack_public_path__ + "static/media/file-document-outline.2fc69c09.svg";